module.exports = __webpack_public_path__ + "static/media/heart15.3575be43.svg";